module.exports = __webpack_public_path__ + "img/carrousel-arco-digi-2.1b556d1f.png";